export default "__VITE_ASSET__292c1f13__"